import {AnyExtension} from '@tiptap/core'
import {Subscript} from '@tiptap/extension-subscript'
import {Superscript} from '@tiptap/extension-superscript'
import {TableKit} from '@tiptap/extension-table'
import {TextAlign} from '@tiptap/extension-text-align'
import {BackgroundColor, Color, FontFamily, FontSize, TextStyle} from '@tiptap/extension-text-style'
import {Placeholder} from '@tiptap/extensions'
import StarterKit from '@tiptap/starter-kit'

import {TextDirection} from './direction'
import {BlockIndent} from './indent'
import {ResizableImage} from './resizableImage'
import {BlockSpacing} from './spacing'
import {VideoEmbed} from './videoEmbed'

export const buildRichTextExtensions = (placeholder?: string): AnyExtension[] => [
  StarterKit.configure({
    heading: {levels: [1, 2, 3, 4, 5, 6]},
    link: {
      openOnClick: false,
      autolink: true,
      defaultProtocol: 'https',
    },
  }),
  TextStyle,
  Color,
  BackgroundColor,
  FontFamily,
  FontSize,
  TextAlign.configure({types: ['heading', 'paragraph']}),
  Subscript,
  Superscript,
  TableKit.configure({
    table: {resizable: false, HTMLAttributes: {class: 'table table-bordered'}},
  }),
  ResizableImage,
  VideoEmbed,
  BlockIndent,
  BlockSpacing,
  TextDirection,
  Placeholder.configure({placeholder: placeholder ?? ''}),
]
